import { useEffect, useState } from "react";

/**
 * Simple seconds-remaining countdown. Pass a deadline (ms-epoch)
 * or null to disable. Returns max(0, seconds-remaining).
 *
 * The hook polls every 1s — perfectly adequate for OTP TTL and
 * resend-disabled windows. Use a smaller cadence elsewhere if
 * sub-second accuracy matters.
 */
export function useCountdown(deadlineMs: number | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (deadlineMs == null) return;
    const tick = () => setNow(Date.now());
    tick();
    const id = setInterval(tick, 1_000);
    return () => clearInterval(id);
  }, [deadlineMs]);

  if (deadlineMs == null) return 0;
  return Math.max(0, Math.ceil((deadlineMs - now) / 1_000));
}
